import {ProductPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Model from './ModelAmar.mjs'
import Am from '../AM/PropertiesControllerAm.jsx'

export default function PropertiesPaneDo(props) {
    return (
        <ProductPropertiesPane
            controllers={
                <>
                    <Am />
                    <Text prop="arNo" />
                    <Text prop="arName" />
                    <LongText prop="memo" />
                    <LongText prop="resume" />
                </>
            }

            Model={Model}

            snSuffix={
                <Analyse
                    modes={[
                        'ChgReferenceSingle',
                        'Reference',
                        'ReferenceCall',
                        'IsrfReference',
                    ]}
                />
            }

            {...props}
        />
    )
}
